/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".hx-pull-right{float:right!important}.margin-top-5{margin-top:5px}.margin-bottom-5{margin-bottom:5px}.edit_mode{border:1px solid #f75404}.big_title{padding:20px;color:#fff;font-size:140%}.hx-status-text{font-weight:700}"];
export { styles as styles };
